export function stringToPath(path: string | string[]): string[] {
  if (!path) return [];

  return Array.isArray(path) ? path : path.split('.');
}

export function get(obj: object, path: string | string[], defaultValue?: any): any {
  const keys = stringToPath(path);

  let result: Record<string, any> = obj;
  for (let key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return defaultValue;
    }
  }

  return result !== undefined ? result : defaultValue;
}
